import { API_URLS } from "../../constants/apiUrls";
import { commonFetch } from "../commonFetch";
  
   export const getAllClassSubjectMapping = async (formData) =>
  commonFetch(API_URLS.GET_ALL_CLASS_SUBJECT_MAPPING_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });

export const GetClassTeacherSubjectMapping = async (teacherId, schoolId) =>
  commonFetch(
    `${API_URLS.GET_ALL_CLASS_TEACHER_SUBJECT_MAPPING_APIURL}?teacherId=${teacherId}&schoolId=${schoolId}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );

